var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { WebsocketContext } from "./WebsocketProvider";
import { useEngine } from "./useEngine";
import { explainScoringCache, getExplainScoringKey } from "./util/cachePrefill";
export var GameScoringSettings = function (props) {
    var send = React.useContext(WebsocketContext).send;
    var engine = useEngine();
    var _a = React.useState(null), highlighted = _a[0], setHighlighted = _a[1];
    var _b = React.useState([]), scoreTransitions = _b[0], setScoreTransitions = _b[1];
    var _c = React.useState([]), bonusScoreTransitions = _c[0], setBonusScoreTransitions = _c[1];
    var _d = React.useState(10), stepSize = _d[0], setStepSize = _d[1];
    var _e = React.useState(100), totalPoints = _e[0], setTotalPoints = _e[1];
    var _f = React.useState(true), isLoading = _f[0], setIsLoading = _f[1];
    var updateSettings = function (updates) {
        send({
            Action: {
                SetGameScoringParameters: __assign(__assign({}, props.params), updates),
            },
        });
    };
    var bonusEnabled = props.params.bonus_level_policy === "BonusLevelForSmallerLandlordTeam";
    React.useEffect(function () {
        setIsLoading(true);
        // Load regular scoring
        var loadScoring = function () { return __awaiter(void 0, void 0, void 0, function () {
            var regularKey, regular, bonusKey, bonus, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        regularKey = getExplainScoringKey(props.params, false, props.decks);
                        regular = explainScoringCache[regularKey];
                        if (!!regular) return [3 /*break*/, 2];
                        return [4 /*yield*/, engine.explainScoring({
                                params: props.params,
                                smaller_landlord_team_size: false,
                                decks: props.decks,
                            })];
                    case 1:
                        regular = _a.sent();
                        explainScoringCache[regularKey] = regular;
                        _a.label = 2;
                    case 2:
                        setScoreTransitions(regular.results);
                        setStepSize(regular.step_size);
                        setTotalPoints(regular.total_points);
                        if (!bonusEnabled) return [3 /*break*/, 5];
                        bonusKey = getExplainScoringKey(props.params, true, props.decks);
                        bonus = explainScoringCache[bonusKey];
                        if (!!bonus) return [3 /*break*/, 4];
                        return [4 /*yield*/, engine.explainScoring({
                                params: props.params,
                                smaller_landlord_team_size: true,
                                decks: props.decks,
                            })];
                    case 3:
                        bonus = _a.sent();
                        explainScoringCache[bonusKey] = bonus;
                        _a.label = 4;
                    case 4:
                        setBonusScoreTransitions(bonus.results);
                        return [3 /*break*/, 6];
                    case 5:
                        setBonusScoreTransitions(regular.results);
                        _a.label = 6;
                    case 6:
                        setIsLoading(false);
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        console.error("Error explaining scoring:", error_1);
                        // Set defaults
                        setScoreTransitions([]);
                        setBonusScoreTransitions([]);
                        setStepSize(10);
                        setTotalPoints(100);
                        setIsLoading(false);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        loadScoring();
    }, [props.params, props.decks, bonusEnabled, engine]);
    if (isLoading) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, "Loading scoring settings...")));
    }
    var scoreSegments = [];
    var maxPts = 0;
    var maxLandlordDelta = 0;
    var maxNonLandlordDelta = 0;
    if (scoreTransitions.length > 0) {
        for (var i = 1; i < scoreTransitions.length; i++) {
            var span = Math.max(scoreTransitions[i].point_threshold -
                scoreTransitions[i - 1].point_threshold, 10);
            var segment = scoreTransitions[i - 1];
            maxLandlordDelta = Math.max(segment.results.landlord_delta, maxLandlordDelta);
            maxNonLandlordDelta = Math.max(segment.results.non_landlord_delta, maxNonLandlordDelta);
            scoreSegments.push({
                span: span,
                segment: segment,
                bonusSegment: bonusScoreTransitions.length > i - 1 &&
                    bonusScoreTransitions[i - 1].results.landlord_bonus
                    ? bonusScoreTransitions[i - 1]
                    : null,
            });
            maxPts += span;
        }
        var last = scoreTransitions.length - 1;
        scoreSegments.push({
            span: 5 * props.decks.length,
            segment: scoreTransitions[last],
            bonusSegment: bonusScoreTransitions.length > last &&
                bonusScoreTransitions[last].results.landlord_bonus
                ? bonusScoreTransitions[last]
                : null,
        });
        maxPts += 5 * props.decks.length;
        maxNonLandlordDelta = Math.max(scoreTransitions[last].results.non_landlord_delta, maxNonLandlordDelta);
        maxLandlordDelta = Math.max(scoreTransitions[last].results.landlord_delta, maxLandlordDelta);
    }
    var text = function (idx) {
        var txt = "Attacking team wins, but doesn't level up.";
        var segment = scoreSegments[idx];
        if (segment.segment.results.landlord_won) {
            txt = "Defending team wins, and goes up ".concat(segment.segment.results.landlord_delta, " level").concat(segment.segment.results.landlord_delta === 1 ? "" : "s", ".");
            if (segment.bonusSegment !== null) {
                txt += " If the team is unexpectedly small, they go up ".concat(segment.bonusSegment.results.landlord_delta, " level").concat(segment.bonusSegment.results.landlord_delta === 1 ? "" : "s", ".");
            }
        }
        else if (segment.segment.results.non_landlord_delta > 0) {
            txt = "Attacking team wins, and goes up ".concat(segment.segment.results.non_landlord_delta, " level").concat(segment.segment.results.non_landlord_delta === 1 ? "" : "s", ".");
        }
        return React.createElement(React.Fragment, null, txt);
    };
    var validStepSizes = [];
    for (var curStepSize = 0; curStepSize <= totalPoints / 3; curStepSize += 5 * props.decks.length) {
        if (curStepSize === 0) {
            continue;
        }
        if (totalPoints % curStepSize === 0) {
            validStepSizes.push("".concat(curStepSize));
        }
    }
    var maxSteps = Math.floor(totalPoints / stepSize);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { style: { width: "95%", padding: "5px 0 5px 0" } },
                scoreSegments.map(function (segment, idx) {
                    var frac = segment.span / maxPts;
                    var bg = "rgb(255, 255, 0)";
                    if (segment.segment.results.landlord_won) {
                        var f = segment.segment.results.landlord_delta / maxLandlordDelta;
                        bg = "rgba(0, 255, 0, ".concat(f, ")");
                    }
                    else if (segment.segment.results.non_landlord_delta > 0) {
                        var f = segment.segment.results.non_landlord_delta /
                            maxNonLandlordDelta;
                        bg = "rgba(255, 0, 0, ".concat(f, ")");
                    }
                    return (React.createElement("div", { key: idx, onMouseEnter: function (_) {
                            setHighlighted(idx);
                        }, onMouseLeave: function (_) {
                            setHighlighted(null);
                        }, style: {
                            width: "".concat(100 * frac, "%"),
                            background: bg,
                            padding: "5px 0 5px 0",
                            display: "inline-block",
                            cursor: "pointer",
                        } }, segment.segment.point_threshold));
                }),
                highlighted !== null ? (React.createElement("p", null,
                    " ",
                    text(highlighted))) : (React.createElement("p", null, "Hover over the scores above for more details."))),
            React.createElement("div", null,
                React.createElement("label", null,
                    "Step size: ",
                    stepSize,
                    " points")),
            React.createElement("div", null,
                React.createElement("label", null, "Base step size: "),
                React.createElement("select", { value: "".concat(props.params.step_size_per_deck * props.decks.length), onChange: function (evt) {
                        evt.preventDefault();
                        var perDeck = parseInt(evt.target.value, 10) / props.decks.length;
                        updateSettings({
                            step_size_per_deck: perDeck,
                        });
                    } }, validStepSizes.map(function (ss, idx) { return (React.createElement("option", { key: idx }, ss)); })),
                " ",
                "(default: ",
                20 * props.decks.length,
                ")"),
            React.createElement("div", null,
                React.createElement("label", null,
                    "Adjustment to step size for ",
                    props.decks.length,
                    " decks:",
                    " "),
                React.createElement("select", { value: props.params.step_adjustments[props.decks.length] !== undefined
                        ? props.params.step_adjustments[props.decks.length]
                        : "none", onChange: function (evt) {
                        var _a;
                        evt.preventDefault();
                        if (evt.target.value === "none") {
                            var _b = props.params.step_adjustments, _c = props.decks.length, _1 = _b[_c], adjustments = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
                            updateSettings({ step_adjustments: adjustments });
                        }
                        else {
                            var adjustments = __assign(__assign({}, props.params.step_adjustments), (_a = {}, _a[props.decks.length] = parseInt(evt.target.value, 10), _a));
                            updateSettings({ step_adjustments: adjustments });
                        }
                    } },
                    React.createElement("option", { key: "none" }, "none"),
                    Array((props.params.step_size_per_deck * props.decks.length) / 5)
                        .fill(undefined)
                        .map(function (_, idx) { return (React.createElement("option", { key: idx }, (idx + 1) * 5)); })),
                " ",
                "(default: none)"),
            React.createElement("div", null,
                React.createElement("label", null, "Number of steps where nobody gains a level: "),
                React.createElement("select", { value: "".concat(props.params.deadzone_size), onChange: function (evt) {
                        evt.preventDefault();
                        var deadzoneSize = parseInt(evt.target.value, 10);
                        updateSettings({
                            deadzone_size: deadzoneSize,
                        });
                    } }, Array(Math.max(maxSteps, props.params.deadzone_size))
                    .fill(undefined)
                    .map(function (_, idx) { return (React.createElement("option", { key: idx }, idx)); })),
                " ",
                "(default: 1)"),
            React.createElement("div", null,
                React.createElement("label", null, "Number of steps for the attacking team to win: "),
                React.createElement("select", { value: "".concat(props.params.num_steps_to_non_landlord_turnover), onChange: function (evt) {
                        evt.preventDefault();
                        var steps = parseInt(evt.target.value, 10);
                        updateSettings({
                            num_steps_to_non_landlord_turnover: steps,
                        });
                    } }, Array(Math.max(maxSteps, props.params.num_steps_to_non_landlord_turnover))
                    .fill(undefined)
                    .map(function (_, idx) { return (React.createElement("option", { key: idx + 1 }, idx + 1)); })),
                " ",
                "(default: 2)"),
            React.createElement("div", null,
                React.createElement("label", null, "Grant a bonus level for unexpectedly small team"),
                " ",
                React.createElement("input", { id: "small-team-bonus", type: "checkbox", onChange: function (evt) {
                        evt.preventDefault();
                        updateSettings({
                            bonus_level_policy: evt.target.checked
                                ? "BonusLevelForSmallerLandlordTeam"
                                : "NoBonusLevel",
                        });
                    }, checked: bonusEnabled })))));
};
